<template>
  <section>
    <event-registration-info
      :event="event"
      v-if="beforeTheEvent()"
    ></event-registration-info>
    <event-live-streaming-info
      :event="event"
      v-if="duringTheEvent()"
    ></event-live-streaming-info>
    <event-basic-info
      :event="event"
      v-if="afterTheEvent()"
    ></event-basic-info>
  </section>
</template>

<script>
import Vue from 'vue'

import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

import EventBasicInfo from '@/components/info/EventBasicInfo'
import EventLiveStreamingInfo from '@/components/info/EventLiveStreamingInfo'
import EventRegistrationInfo from '@/components/info/EventRegistrationInfo'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: 'event-info',
  props: {
    event: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    beforeTheEvent() {
      const start_date = dayjs(this.event.start_date);
      const current_date = dayjs();
      return current_date.isBefore(start_date, 'day')
    },
    duringTheEvent() {
      dayjs.extend(isSameOrAfter)
      dayjs.extend(isSameOrBefore)

      const start_date = dayjs(this.event.start_date);
      const end_date = dayjs(this.event.end_date);
      const current_date = dayjs();
      return current_date.isSameOrAfter(start_date, 'day') && current_date.isSameOrBefore(end_date, 'day')
    },
    afterTheEvent() {
      const end_date = dayjs(this.event.end_date);
      const current_date = dayjs();
      return current_date.isAfter(end_date, 'day')
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    EventBasicInfo,
    EventLiveStreamingInfo,
    EventRegistrationInfo
  }  
}
</script>